import Sidebar from "../../DesignSystem/Sidebar";
import AdminApprovals from "./AdminApprovals";
import AdminSubmissionDetails from "./AdminSubmissionDetails";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";

export default function AdminMediaPage() {
  const { userEmail, submissionId } = useParams();
  const isDetailsPage = Boolean(userEmail && submissionId);

  return (
    <div className="main-content">
      <Helmet>
        <title>Financial Promotions</title>
        <meta
          name="description"
          content="Admin page for uploading financial promotions for compliance review and approval."
        />
      </Helmet>
      <Sidebar />
      {isDetailsPage ? <AdminSubmissionDetails /> : <AdminApprovals />}
    </div>
  );
}
